import React from "react";
import { bool, string } from "prop-types";
import { GLOBAL } from "@Config/global";
import Button from "@Components/Button";
import './styles.scss';

const { FILE_UPLOAD } = GLOBAL;

export default class FileUploadMultiple extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],   // { id, name, file: File }
      identity: 0,
    };

    this.uploadButtonRef = React.createRef();
  }

  getFiles = () => {
    return this.state.items.map(item => ({
      name: item.name,
      file: item.file, 
    }));
  };

  clearFiles = () => {
    this.setState({ items: [], identity: 0 }, () => {
      if (this.uploadButtonRef.current) this.uploadButtonRef.current.value = "";
    });
  };

  onChange = (e) => {
    const fileList = e.target.files || [];
    const incoming = Array.from(fileList); 

    const dedup = new Map();
    [...this.state.items, ...incoming.map(f => ({ file: f, name: f.name }))].forEach((it, idx) => {
      const f = it.file || it; 
      const key = `${f.name}_${f.size}_${f.lastModified}`;
      if (!dedup.has(key)) {
        dedup.set(key, {
          id: idx,
          name: f.name,
          file: f
        });
      }
    });

    const merged = Array.from(dedup.values()).map((it, i) => ({
      ...it,
      id: i
    }));

    this.setState(prev => ({
      items: merged.map((it, i) => ({ ...it, id: i })),
      identity: merged.length
    }));

    e.target.value = "";
  };

  removeFile = (id) => {
    const items = this.state.items.filter(f => f.id !== id).map((f, i) => ({ ...f, id: i }));
    this.setState({ items, identity: items.length });
  };

  onButtonClick = () => {
    if (!this.props.disabled && this.uploadButtonRef.current) {
      this.uploadButtonRef.current.click();
    }
  };

  render() {
    const { multiple, disabled, accept } = this.props;

    return (
      <>
        <div className="col-md-12">
          {(multiple || this.state.items.length === 0) && (
            <Button
              type="button"
              fill="outline"
              size="medium"
              onClick={this.onButtonClick}
              disabled={disabled}
            >
              {FILE_UPLOAD.TEXT}
            </Button>
          )}

          <input
            ref={this.uploadButtonRef}
            type="file"
            id="file"
            multiple={multiple}
            hidden
            disabled={disabled}
            accept={accept}
            onChange={this.onChange}
          />
        </div>

        <div className="col-md-12 tag-editor-container">
          {this.state.items.map((item) => (
            <div className="tag-editor" key={`${item.name}_${item.file.size}_${item.file.lastModified}`}>
              <div className="tag-editor-tag">{item.name}</div>
              <div
                className="tag-editor-delete"
                title="quitar"
                onClick={() => this.removeFile(item.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.removeFile(item.id);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                x
              </div>
              <div className="tag-editor-spacer">&nbsp;,</div>
            </div>
          ))}
        </div>
      </>
    );
  }
}

FileUploadMultiple.propTypes = {
  disabled: bool,
  multiple: bool,
  accept: string, // extensiones ".pdf,.jpg,.png,.csv,.xls,.xlsx"
};

FileUploadMultiple.defaultProps = {
  disabled: false,
  multiple: true,
  accept: undefined,
};
